import { render, staticRenderFns } from "./PDFPreviewer.vue?vue&type=template&id=8dbaf4ee&scoped=true&"
import script from "./PDFPreviewer.vue?vue&type=script&lang=js&"
export * from "./PDFPreviewer.vue?vue&type=script&lang=js&"
import style0 from "./PDFPreviewer.vue?vue&type=style&index=0&id=8dbaf4ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbaf4ee",
  null
  
)

export default component.exports